import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import ENTITLEMENTS_ORGANIZATION_QUERY, {
	type entitlementsOrganizationQuery,
} from '@atlassian/jira-relay/src/__generated__/entitlementsOrganizationQuery.graphql';

export const entitlementsOrganizationQueryResource =
	createRelayResource<entitlementsOrganizationQuery>({
		type: 'ENTITLEMENTS_ORGANIZATION_QUERY',
		getQuery: ({ match }, { tenantContext }) => ({
			parameters: ENTITLEMENTS_ORGANIZATION_QUERY,
			variables: {
				organizationId: String(match.params.organizationId),
				cloudId: tenantContext.cloudId,
			},
			options: { fetchPolicy: 'store-and-network' },
		}),
	});
